module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAVtJREFUSA3N1T1WhDAUBWBCZwdr0nbszBLYgMfFwBJSqqWzJugsMRdzOYxDyHshhSkmTH7uN8mZhKoKpe/7F+fcA7+XqpGJbObVePANr75y0zS9l0SRhUxkB6MyQXeAUYwxX03TPFtrv39b8j6JzfP8tEmwddu2n0DYiAFnV7qHwVgsQLEBOStNZRmuLDWQ445qScYKIkgyIQZK596AuagUQ/4dqEU1WBSUolrsEEyh6Mfx2Z4zyRne3VKEscRWgX4thjlJEIP2ULSzSFa2juVDqo6hGgzGcnmnsJL9/29LI1t5Dat+5OqlW3u4whjmb/0LoHEcP3ylQqPgEcZ3JcZo0V1QgnErtegdqMFy0BswB9OiK3gG06ALWAKToqYkJkFr/4q5bG99P+mKc8a/PkM0NeaGs8oLYnmzwKq7rnP+lngLgacx/rC/KAxY7K+GYbDY3rWh0AMykc24H43U6vht2wSVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x.png
// module id = VgmL
// module chunks = 0